import { ReactElement } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { BsBuildings, BsCollection, BsFolder, BsFolder2, BsFolder2Open, BsPeople } from 'react-icons/bs';
import { GoOrganization } from "react-icons/go";
import { MdHomeWork, MdOutlinePersonPin } from 'react-icons/md';
import { FaAlignCenter, FaHands } from "react-icons/fa";
import { FaHandshakeSimple } from "react-icons/fa6";
import { GrCatalogOption } from "react-icons/gr";
import { IoMdPerson, IoMdPersonAdd } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { PiHandCoinsBold, PiHandCoinsFill, PiMoney } from "react-icons/pi";
import { GiMoneyStack, GiTakeMyMoney } from "react-icons/gi";

export type SidebarItem = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  dynamicSubNav?: boolean;
};

export type SidebarGroup = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  subNav?: SidebarItem[];
};

type SidebarElement = SidebarItem | SidebarGroup;


export const buildSidebarData = (): SidebarElement[] => [
  {
    title: "Dashboard",
    path: "#",
    icon: <AiOutlineHome />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Overview",
        path: "/dashboard/overview",
        icon: <AiOutlineHome />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Succession",
        path: "/dashboard/succession",
        icon: <FaHandshakeSimple />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Wealth Stability",
        path: "/dashboard/wealth-stability",
        icon: <GiMoneyStack />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Projects",
        path: "/dashboard/projects",
        icon: <BsFolder />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Cap Table",
        path: "/dashboard/cap-table",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Audits",
        path: "/dashboard/audits",
        icon: <BsCollection />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Mentorship",
        path: "/dashboard/mentorship",
        icon: <BsPeople />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "PassionIT Score",
        path: "/dashboard/passionit-score",
        icon: <FaAlignCenter />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ]
  },
  // common
  {
    title: "Common",
    path: "#",
    icon: <FiUsers />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Country",
        path: "/common/country",
        icon: <BsPeople />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "State",
        path: "/common/state",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
    ]
  },
  //user master
  {
    title: "User Masters",
    path: "#",
    icon: <FiUsers />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      // {
      //   title: "Organization Master",
      //   path: "/user-master/organization-master",
      //   icon: <GoOrganization />,
      //   cName: "sub-nav-text",
      //   roles: ["admin"]
      // },
      {
        title: "User Master",
        path: "/user-master/user",
        icon: <BsPeople />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
      {
        title: "User Subscriber",
        path: "/user-master/user-subscriber",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
      {
        title: "User Group",
        path: "/user-master/user-group",
        icon: <BsCollection />,
        cName: "sub-nav-text",
      },
    ]
  },
  {
    title: "Risk Assessment Log",
    path: "/common/risk-assessment-log",
    icon: <GrCatalogOption />,
    cName: "nav-text",
    // roles: ["Admin", "User"],
    roles: ["Admin"],

  },
  //document master
  {
    title: "Document Management",
    path: "#",
    icon: <BsFolder />,
    cName: "nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Document Type",
        path: "/document/document-type",
        icon: <BsFolder2Open />,
        cName: "sub-nav-text",
        roles: ["admin"]
      },
      {
        title: "Document Master",
        path: "/document/document-master",
        icon: <BsFolder2 />,
        cName: "sub-nav-text",
        roles: ["admin"]

      },
    ]
  },
  // entity and investment
  {
    title: "Entities And Investment",
    path: "#",
    icon: <FaAlignCenter />,
    cName: "sub-nav-text",
    // roles: ["admin", "user"],
    roles: ["Admin"],
    subNav: [
      {
        title: "Entity Type Master",
        path: "/gmis-master/entity-type-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Entity Master",
        path: "/gmis-master/entity-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Investment Mandate Type",
        path: "/gmis-master/investment-mandate-type",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Entity Cap",
        path: "/gmis-master/entity-cap",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Mentor Ship",
        path: "/gmis-master/mentorship-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      }
      // {
      //   title: "Founder Master",
      //   path: "/gmis-master/founder-master",
      //   icon: <FaHandshakeSimple />,
      //   cName: "sub-nav-text",
      //   roles: ["admin"],
      // },
    ],
  },
  // events
  {
    title: "BCP and Disaster Recovery",
    path: "#",
    icon: <FaAlignCenter />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Event Type",
        path: "/events/event-type",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Event Master",
        path: "/events/event-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Sovereign Event Ledger",
        path: "/events/sovereign-event-ledger",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
  //opportunity
  {
    title: "Opportunity",
    path: "#",
    icon: <FaHands />,
    cName: "sub-nav-text",
    // roles: ["admin", "user"],
    roles: ["Admin"],
    subNav: [
      {
        title: "Opportunity Type",
        path: "/opportunity/opportunity-type",
        icon: <PiHandCoinsBold />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Opportunity Master",
        path: "/opportunity/opportunity-master",
        icon: <PiHandCoinsFill />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Opportunity Application",
        path: "/opportunity/opportunity-application",
        icon: <IoDocumentTextOutline />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Opportunity Applicant Interview",
        path: "/opportunity/opportunity-applicant-interview",
        icon: <IoDocumentTextOutline />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Member Interview Records",
        path: "/opportunity/member-interview-records",
        icon: <IoMdPersonAdd />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Opportunity Allocation",
        path: "/opportunity/opportunity-allocation",
        icon: <MdOutlinePersonPin />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
  // Angel Office
  // {
  //   title: "Angel Office",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],
  //   subNav: [
  //     {
  //       title: "Pipeline",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Investors",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Startup",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Deals",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Monitoring",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Exits",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  //family office
  {
    title: "Family Office Investments",
    path: "#",
    icon: <FaAlignCenter />,
    cName: "sub-nav-text",
    // roles: ["admin", "user"],
    roles: ["Admin"],
    subNav: [
      {
        title: "Family Office Master",
        path: "/gmis-master/family-office-master",
        icon: <MdHomeWork />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      // {
      //   title: "Members",
      //   path: "/fo-investment/entity-master",
      //   icon: <IoMdPerson />,
      //   cName: "sub-nav-text",
      //   roles: ["admin"],
      // },
      {
        title: "Asset Type",
        path: "/fo-investment/asset-type",
        icon: <GiMoneyStack />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Assets",
        path: "/fo-investment/assets",
        icon: <PiMoney />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Investments",
        path: "/fo-investment/investment-master",
        icon: <GiTakeMyMoney />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      // {
      //   title: "Transactions",
      //   path: "/fo-investment/founder-master",
      //   icon: <FaHandshakeSimple />,
      //   cName: "sub-nav-text",
      //   roles: ["admin"],
      // },
      // {
      //   title: "Reports",
      //   path: "/fo-investment/founder-master",
      //   icon: <FaHandshakeSimple />,
      //   cName: "sub-nav-text",
      //   roles: ["admin"],
      // },
    ],
  },
  // CSR
  // {
  //   title: "CSR And Sub-Projects",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],
  //   subNav: [
  //     {
  //       title: "Applicant NGO Proposals",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Shortlisting & Approvals",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "NGO → Sub-NGO Mapping",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "CSR Projects",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Logical Framework",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Monitoring & Control",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  // Accelarator Incubator Office
  // {
  //   title: "Accelerator / Incubator Management",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],
  //   subNav: [
  //     {
  //       title: "Startups",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Cohorts",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Pitch Events",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Pitch Pipeline",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Mentors",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Funding & Finance",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "KPI & Traction",
  //       path: "/gmis-master/founder-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Audits",
  //       path: "/gmis-master/founder-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  // Project Monitoring and Control
  // {
  //   title: "Project Monitoring and Control",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],

  //   subNav: [
  //     {
  //       title: "Project Master",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Monitoring",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Business Canvas",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Logical Framework",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Risk Register (All Projects)",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Traction Metrics (All Projects)",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  // Audits and Compliance
  // {
  //   title: "Audits & Checklists",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],
  //   subNav: [
  //     {
  //       title: "Audits",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Templates",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Documents",
  //       path: "/gmis-master/deal-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  // {
  //   title: "Founder Reviews",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],
  //   subNav: [
  //     {
  //       title: "Founder Assessments",
  //       path: "/gmis-master/project-master",
  //       icon: <GoOrganization />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
  // {
  //   title: "GMIS Master",
  //   path: "#",
  //   icon: <FaAlignCenter />,
  //   cName: "sub-nav-text",
  //   // roles: ["admin", "user"],
  //   roles: ["Admin"],
  //   subNav: [
  //     {
  //       title: "Family Office Master",
  //       path: "/gmis-master/family-office-master",
  //       icon: <MdHomeWork />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //     {
  //       title: "Sponsor Master",
  //       path: "/gmis-master/sponsor-master",
  //       icon: <FaHandshakeSimple />,
  //       cName: "sub-nav-text",
  //       roles: ["admin"],
  //     },
  //   ],
  // },
];
